import { lazy } from 'react';

export const MyNotificationsPage = lazy(() => import('./MyNotificationsPage'));
